export const FilterListByName = (term, list) => {
  return list.filter((entry) => entry.name.toLocaleLowerCase().includes(term.toLocaleLowerCase()));
};
